// CUSTOM: Klaviyo Popup Trigger
document.addEventListener("DOMContentLoaded", function() {
  const klaviyoPopups = document.querySelectorAll('.klaviyo_form_trigger');

  klaviyoPopups.forEach((klaviyoPopup) => {
    klaviyoPopup.setAttribute('aria-disabled', 'false');
    klaviyoPopup.style.cursor = 'pointer';

    klaviyoPopup.addEventListener('click', function() {
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', klaviyoPopup.dataset.klaviyoId]);
    });
  });
});
